/**
 * Placeholder Image Utilities
 * เครื่องมือสำหรับสร้าง placeholder image เมื่อไม่มีรูป
 */

/**
 * สร้าง placeholder image สำหรับน้องที่ไม่มีรูป
 * @param {string} nickname - ชื่อของน้อง
 * @param {string} type - ประเภทของน้อง (normal, premium, vip)
 * @returns {string} - Data URL ของ placeholder image
 */
export const createGirlPlaceholder = (nickname = 'น้องใหม่', type = 'normal') => {
  // สีพื้นหลังตามประเภท
  const backgroundColor = {
    normal: '#FFB6C1', // สีชมพูอ่อน
    premium: '#FFD700', // สีทอง
    vip: '#FF69B4' // สีชมพูเข้ม
  }[type] || '#FFB6C1';

  // สีข้อความ
  const textColor = '#333333';
  
  // สร้าง SVG
  const svg = `
    <svg width="300" height="400" viewBox="0 0 300 400" fill="none" xmlns="http://www.w3.org/2000/svg">
      <!-- พื้นหลัง -->
      <rect width="300" height="400" fill="${backgroundColor}" rx="20"/>
      
      <!-- กรอบ -->
      <rect x="10" y="10" width="280" height="380" fill="none" stroke="${textColor}" stroke-width="2" rx="15"/>
      
      <!-- ไอคอนคน -->
      <circle cx="150" cy="120" r="40" fill="${textColor}"/>
      <path d="M 100 200 Q 150 180 200 200 L 200 280 Q 150 300 100 280 Z" fill="${textColor}"/>
      
      <!-- ข้อความ -->
      <text x="150" y="350" font-family="Arial, sans-serif" font-size="18" fill="${textColor}" text-anchor="middle" font-weight="bold">
        ${nickname}
      </text>
      
      <!-- สถานะ -->
      <text x="150" y="375" font-family="Arial, sans-serif" font-size="12" fill="${textColor}" text-anchor="middle">
        ${type.toUpperCase()}
      </text>
    </svg>
  `;
  
  return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`;
};

/**
 * สร้าง placeholder image สำหรับรูปที่ไม่มี
 * @param {string} text - ข้อความที่จะแสดง
 * @param {string} icon - ไอคอนที่จะแสดง (emoji)
 * @returns {string} - Data URL ของ placeholder image
 */
export const createImagePlaceholder = (text = 'ไม่มีรูป', icon = '📷') => {
  const svg = `
    <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      <!-- พื้นหลัง -->
      <rect width="200" height="200" fill="#F3F4F6" rx="10"/>
      
      <!-- กรอบ -->
      <rect x="10" y="10" width="180" height="180" fill="none" stroke="#D1D5DB" stroke-width="2" rx="5"/>
      
      <!-- ไอคอน -->
      <text x="100" y="100" font-family="Arial, sans-serif" font-size="48" text-anchor="middle" dominant-baseline="middle">
        ${icon}
      </text>
      
      <!-- ข้อความ -->
      <text x="100" y="140" font-family="Arial, sans-serif" font-size="14" fill="#6B7280" text-anchor="middle">
        ${text}
      </text>
    </svg>
  `;
  
  return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`;
};

/**
 * สร้าง placeholder image สำหรับรูปที่รออนุมัติ
 * @returns {string} - Data URL ของ placeholder image
 */
export const createPendingPlaceholder = () => {
  return createImagePlaceholder('รออนุมัติ', '⏳');
};

/**
 * สร้าง placeholder image สำหรับรูปที่ปฏิเสธ
 * @returns {string} - Data URL ของ placeholder image
 */
export const createRejectedPlaceholder = () => {
  return createImagePlaceholder('ถูกปฏิเสธ', '❌');
};

/**
 * สร้าง placeholder image สำหรับรูปที่อนุมัติแล้ว
 * @returns {string} - Data URL ของ placeholder image
 */
export const createApprovedPlaceholder = () => {
  return createImagePlaceholder('อนุมัติแล้ว', '✅');
};

/**
 * ตรวจสอบว่าเป็น placeholder image หรือไม่
 * @param {string} imageUrl - URL ของรูปภาพ
 * @returns {boolean}
 */
export const isPlaceholderImage = (imageUrl) => {
  return imageUrl && imageUrl.startsWith('data:image/svg+xml;base64,');
};

/**
 * สร้าง placeholder image สำหรับรูปโปรไฟล์
 * @param {string} nickname - ชื่อของน้อง
 * @param {string} type - ประเภทของน้อง
 * @returns {string} - Data URL ของ placeholder image
 */
export const createProfilePlaceholder = (nickname = 'น้องใหม่', type = 'normal') => {
  return createGirlPlaceholder(nickname, type);
};
